var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsInstagramNewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_sns_instagram_new_filled_svg__clip0_37861_449395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.008 2.212c-5.757 0-7.44.006-7.768.033-1.181.098-1.917.284-2.717.683a5.505 5.505 0 00-1.585 1.16c-.875.908-1.405 2.026-1.597 3.354-.094.645-.12.777-.126 4.07-.002 1.098 0 2.543 0 4.481 0 5.753.006 7.435.034 7.762.095 1.15.276 1.873.657 2.664a5.81 5.81 0 003.765 3.076c.569.146 1.197.227 2.003.265.341.015 3.822.026 7.305.026 3.483 0 6.966-.005 7.299-.022.933-.043 1.475-.116 2.074-.271a5.774 5.774 0 003.765-3.082c.375-.772.565-1.523.65-2.613.02-.237.027-4.025.027-7.808 0-3.784-.009-7.564-.027-7.802-.087-1.107-.277-1.852-.663-2.639a5.465 5.465 0 00-1.18-1.617c-.913-.871-2.029-1.402-3.358-1.593-.645-.094-.773-.121-4.07-.127h-4.488z",
    fill: "url(#icon_sns_instagram_new_filled_svg__paint0_radial_37861_449395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.008 2.212c-5.757 0-7.44.006-7.768.033-1.181.098-1.917.284-2.717.683a5.505 5.505 0 00-1.585 1.16c-.875.908-1.405 2.026-1.597 3.354-.094.645-.12.777-.126 4.07-.002 1.098 0 2.543 0 4.481 0 5.753.006 7.435.034 7.762.095 1.15.276 1.873.657 2.664a5.81 5.81 0 003.765 3.076c.569.146 1.197.227 2.003.265.341.015 3.822.026 7.305.026 3.483 0 6.966-.005 7.299-.022.933-.043 1.475-.116 2.074-.271a5.774 5.774 0 003.765-3.082c.375-.772.565-1.523.65-2.613.02-.237.027-4.025.027-7.808 0-3.784-.009-7.564-.027-7.802-.087-1.107-.277-1.852-.663-2.639a5.465 5.465 0 00-1.18-1.617c-.913-.871-2.029-1.402-3.358-1.593-.645-.094-.773-.121-4.07-.127h-4.488z",
    fill: "url(#icon_sns_instagram_new_filled_svg__paint1_radial_37861_449395)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.003 5.818c-2.765 0-3.113.012-4.198.062-1.084.05-1.824.22-2.472.473-.67.26-1.237.608-1.803 1.174A4.998 4.998 0 006.355 9.33c-.253.648-.425 1.388-.473 2.471-.049 1.086-.062 1.434-.062 4.199 0 2.765.013 3.111.062 4.197.05 1.084.221 1.824.473 2.471a4.99 4.99 0 001.174 1.804 4.987 4.987 0 001.803 1.175c.648.252 1.388.424 2.472.473 1.086.05 1.432.062 4.197.062 2.766 0 3.112-.012 4.198-.062 1.084-.05 1.824-.221 2.472-.473a4.982 4.982 0 001.803-1.175 5 5 0 001.175-1.803c.25-.648.422-1.388.473-2.472.048-1.086.061-1.432.061-4.197s-.013-3.112-.061-4.198c-.051-1.084-.223-1.824-.473-2.472a4.998 4.998 0 00-1.175-1.803 4.976 4.976 0 00-1.803-1.174c-.65-.252-1.39-.424-2.474-.473-1.086-.05-1.431-.062-4.197-.062h.003zm-.914 1.835h.914c2.718 0 3.04.01 4.114.059.992.045 1.531.21 1.89.35.475.185.814.405 1.17.762.357.356.577.695.762 1.17.14.36.306.898.35 1.89.05 1.074.06 1.396.06 4.114 0 2.717-.01 3.04-.06 4.113-.045.992-.21 1.531-.35 1.89a3.149 3.149 0 01-.762 1.17 3.15 3.15 0 01-1.17.76c-.358.14-.898.306-1.89.352-1.073.048-1.396.059-4.114.059-2.719 0-3.041-.01-4.114-.06-.993-.045-1.532-.211-1.891-.35a3.155 3.155 0 01-1.171-.762A3.157 3.157 0 018.065 22c-.14-.359-.305-.898-.35-1.89-.05-1.074-.06-1.396-.06-4.115 0-2.719.01-3.04.06-4.113.045-.993.21-1.531.35-1.89.185-.476.406-.815.762-1.171a3.16 3.16 0 011.17-.762c.36-.14.899-.306 1.892-.351.939-.043 1.303-.055 3.2-.058v.003zm6.348 1.69a1.222 1.222 0 100 2.445 1.222 1.222 0 000-2.445zm-5.434 1.428a5.229 5.229 0 100 10.458 5.229 5.229 0 000-10.458zm0 1.835a3.394 3.394 0 110 6.788 3.394 3.394 0 010-6.788z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon_sns_instagram_new_filled_svg__paint0_radial_37861_449395",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -27.3273 25.4227 0 9.54 31.91)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon_sns_instagram_new_filled_svg__paint1_radial_37861_449395",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.39819 11.9778 -49.3839 9.88839 -2.406 4.199)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_sns_instagram_new_filled_svg__clip0_37861_449395"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.002 2)",
    d: "M0 0h28v28H0z"
  })))));
}

export default SvgIconSnsInstagramNewFilled;